import React from "react";
import { Modal, Form, Input, Button, DatePicker, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import moment from "dayjs";
const AddDocumentModal = ({ isOpen, onClose, uploadFiles }) => {
  const [form] = Form.useForm();

  const checkForOneFilled = (_, value) => {
    const { type, number, date, file } = form.getFieldsValue();
    if (!type && !number && !date && !file) {
      return Promise.reject(new Error("At least one field must be filled"));
    }
    return Promise.resolve();
  };
  return (
    <Modal
      title="Add Document"
      open={isOpen}
      onCancel={onClose}
      onOk={() => {
        uploadFiles(form);
        onClose();
      }}
      destroyOnClose={true}
    >
      <Form form={form} layout="vertical" initialValues={{ date: moment() }}>
        <Form.Item
          name="type"
          label="Document Type"
          rules={[{ validator: checkForOneFilled }]}
        >
          <Input placeholder="e.g., Invoice, Shipping Label" />
        </Form.Item>
        <Form.Item
          name="number"
          label="Document Number"
          rules={[{ validator: checkForOneFilled }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="date"
          label="Document Date"
          rules={[{ validator: checkForOneFilled }]}
        >
          <DatePicker />
        </Form.Item>
        <Form.Item
          name="file"
          label="Upload File"
          rules={[{ validator: checkForOneFilled }]}
        >
          <Upload
            maxCount={1}
            action="/upload.do"
            listType="text"
            beforeUpload={() => false} // Prevent automatic upload
          >
            <Button icon={<UploadOutlined />}>Click to upload</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddDocumentModal;
